import { useMap } from '@vis.gl/react-google-maps';
import { useEffect } from 'react';

interface MapRefAttacherProps {
  mapRef: React.MutableRefObject<google.maps.Map | null>;
  onMapReady: (map: google.maps.Map) => void;
}

export function MapRefAttacher({ mapRef, onMapReady }: MapRefAttacherProps) {
  const map = useMap();

  useEffect(() => {
    if (!map) {
      return undefined;
    }

    mapRef.current = map;
    onMapReady(map);

    return () => {
      mapRef.current = null;
    };
  }, [map, mapRef, onMapReady]);

  return null;
}
